type StockValue = number | null | undefined;

type ProductQuantityItem = {
  product: { id: number };
  quantity: number;
};

export function isStockUnlimited(stock: StockValue): boolean {
  return stock == null;
}

export function isOutOfStock(stock: StockValue): boolean {
  return stock === 0;
}

export function isLowStock(stock: StockValue, lowStockAlert: StockValue): boolean {
  return stock != null && lowStockAlert != null && stock > 0 && stock <= lowStockAlert;
}

export type ProductStockStatus = 'out_of_stock' | 'low_stock' | 'ok';

export function getProductStockStatus(
  stock: StockValue,
  lowStockAlert: StockValue
): ProductStockStatus {
  if (isOutOfStock(stock)) return 'out_of_stock';
  if (isLowStock(stock, lowStockAlert)) return 'low_stock';
  return 'ok';
}

export function getProductQuantity(
  items: readonly ProductQuantityItem[],
  productId: number
): number {
  return items.reduce(
    (quantity, item) => quantity + (item.product.id === productId ? item.quantity : 0),
    0
  );
}

export function canFulfillStock(stock: StockValue, quantity: number): boolean {
  return stock == null || quantity <= stock;
}

export function getRemainingStock(stock: StockValue, quantity: number): number | null {
  return stock == null ? null : Math.max(0, stock - quantity);
}
